// v-model="showTestDialog"
<template>
   <v-dialog
      
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">This is the Test Dialog</v-card-title>

        <v-card-text>
          <v-text-field label="Select Image" @click='pickFile' v-model='imageName' prepend-icon='attach_file'></v-text-field>
            <input
              type="file"
              style="display: none"
              ref="image"
              accept="image/*"
              @change="onFilePicked"
            >
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            flat="flat"
            @click="setShowTestDialog(false)"
          >
            Cancel
          </v-btn>

          <v-btn
            color="green darken-1"
            flat="flat"
            @click="fileUpload"
          >
            Upload
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

</template>

<script>
import Vuex from 'vuex'
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'FileUpload',

  data () {
    return {
      imageName: '',
      imageUrl: '',
      imageFile: ''
    }
  },

  computed: {
    ...mapState({
                showTestDialog: state => state.ui.showTestDialog,
            }),

  },
  
  methods : {
    ...mapMutations(['setShowTestDialog',]),

    pickFile : function () {
      this.$refs.image.click ()
    },

    onFilePicked (e) {
      const files = e.target.files
      if(files[0] !== undefined) {
        this.imageName = files[0].name
        if(this.imageName.lastIndexOf('.') <= 0) {
          return
        }
        const fr = new FileReader ()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.imageUrl = fr.result
          this.imageFile = files[0] // this is an image file that can be sent to server...
          console.log(this.imageName)
        })
      } else {
        this.imageName = ''
        this.imageFile = ''
        this.imageUrl = ''
      }
    },

    fileUpload: function () {
      //var imageURL = "https://pdc.arizona.edu/images/4.jpg";
      var imageData
      var roomID = "300A+A316"

      const vm = this

      const toDataURL = url => fetch(url)
        .then(response => response.blob())
        .then(blob => new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.onloadend = () => resolve(reader.result)
          reader.onerror = reject
          reader.readAsDataURL(blob)
        }))


      toDataURL(this.imageUrl)
        .then(dataUrl => {
          //console.log('RESULT:', dataUrl)
          imageData = dataUrl;
          fetch("https://api.ba.arizona.edu/if/room/uploadimage" ,
          {
            headers: {
              'Content-Type' : 'application/json'
            },
            method: "POST",
            body: JSON.stringify({"room" : roomID, "image": imageData})
          })
        })
        .then(() => { vm.setShowTestDialog(false) })


    },
  },
}

</script>


<style>

</style>



// WEBPACK FOOTER //
// src/components/forms/FileUploadDialog.vue